import apiClient from './client';

/**
 * Дубли аккаунтов (ADR 0009, «Уточнения Фазы 2»; термины — backend/CONTEXT.md:
 * Дубль, Склейка дубля, Возможный дубль).
 */

export interface UserSummary {
  id: string;
  username: string | null;
  email: string | null;
  firstName: string | null;
  phone: string | null;
  telegramId: string | null;
  telegramUsername: string | null;
  createdAt: string;
  lastLogin: string | null;
  isSubscribed: boolean;
  subscribedEnd: string | null;
  hasPayments: boolean;
  isDeleted: boolean;
  mergedIntoUserId: string | null;
}

export type SuspectedDuplicateStatus = 'open' | 'merged' | 'dismissed';

export interface SuspectedDuplicate {
  id: string;
  status: SuspectedDuplicateStatus;
  detectedAt: string;
  /** Новый Telegram-аккаунт — кандидат в дубли */
  newUser: UserSummary;
  /** Прежний аккаунт на том же устройстве — кандидат в основные */
  previousUser: UserSummary;
}

export interface MergePreview {
  duplicate: UserSummary;
  main: UserSummary;
  canMerge: boolean;
  blockReason: string | null;
  willMove: {
    telegramId: string | null;
    telegramUsername: string | null;
    phone: string | null;
  };
}

export const duplicatesApi = {
  async listSuspected(status: SuspectedDuplicateStatus): Promise<SuspectedDuplicate[]> {
    const res = await apiClient.get<SuspectedDuplicate[]>('/admin/duplicates/suspected', {
      params: { status },
    });
    return res.data;
  },

  async dismiss(id: string): Promise<void> {
    await apiClient.post(`/admin/duplicates/suspected/${id}/dismiss`);
  },

  async searchUsers(q: string): Promise<UserSummary[]> {
    const res = await apiClient.get<UserSummary[]>('/admin/duplicates/users/search', {
      params: { q },
    });
    return res.data;
  },

  async mergePreview(duplicateId: string, mainId: string): Promise<MergePreview> {
    const res = await apiClient.get<MergePreview>('/admin/duplicates/merge-preview', {
      params: { duplicateId, mainId },
    });
    return res.data;
  },

  async merge(duplicateId: string, mainId: string): Promise<void> {
    await apiClient.post('/admin/duplicates/merge', { duplicateId, mainId });
  },
};
